module.exports = __webpack_public_path__ + "static/images/empty-spots.80510bd2d82f3ed3a0f2194f4fdaf650.svg";